/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.Helpers = class Helpers {
  constructor() {}

  animateCSS(node, animationName, callback) {
    var handleAnimationEnd = function() {
      node.classList.remove('animated', animationName);
      node.removeEventListener('animationend', handleAnimationEnd);
      if (typeof callback === 'function') {
        callback();
      }
    };
    node.classList.add('animated', animationName);
    node.addEventListener('animationend', handleAnimationEnd);
  }

  isMobile() {
    return navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i);
  }
};

$(document).ready(() => // 'Copy to clipboard' links
$('[data-behavior~=copy-to-clipboard]').click(function(e) {
  e.preventDefault();
  let clipboardData;
  if($(this).data(`copy-data`)){
    clipboardData = $(this).data(`copy-data`)
  } else {
    clipboardData = $($(this).data('copy-element')).html()
  }
  navigator.clipboard.writeText(clipboardData);
  // This copy alert will happen the "Copy to clipboard" text is not visible. i.e. variables when editing e-mail templates
  if ($(this).data('copy-alert')) {
    this.insertAdjacentHTML('afterend', "<p class='clipboard-alert'>" + $(this).data('copied') + "</p>");
    setTimeout((() => document.querySelectorAll('.clipboard-alert').forEach(clipboardAlert => clipboardAlert.remove())), 1000);
  }
  // This is for when the "Copy to clipboard" text is visible and is changed temporily by what's passed in the "copied" data attribute
  $(this).fadeTo(100, 0.25, function() {
    if ($(this).data('copied')) {
      $(this).find('span').html($(this).data('copied'));
    }
    return $(this).fadeTo(500, 1.0);
  });
  return e.stopPropagation();
}));
